import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { useTheme } from '@mui/material/styles';
import getConfig from 'next/config';
import styles from './styles';

const { publicRuntimeConfig } = getConfig();

const EirErrorPage = props => {
  const theme = useTheme();
  const router = useRouter();

  return (
    <Grid container sx={styles(theme).errorGenricContainer}>
      <Box>
        <Typography variant='h2' sx={styles(theme).errorGenricCode}>
          {props?.errorCode}
        </Typography>
        <Typography variant='h1' sx={styles(theme).errorGenricTitle}>
          {props.title}
        </Typography>
        <Typography variant='body1' sx={styles(theme).errorGenricSubtext}>
          {props.description}
          <br />
          {props.subtext}
        </Typography>
        <Button
          variant='buttonMedium'
          sx={styles(theme).errorButton}
          onClick={() => {
            router.push(publicRuntimeConfig.NEXT_PUBLIC_PATH);
          }}
          aria-label='Go to homepage'
        >
          {props.ctaText}
        </Button>
      </Box>
    </Grid>
  );
};
export default EirErrorPage;
